(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["24k-customer-voices"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('k24-review-form')) {
  customElements.define('k24-review-form', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const form = this.querySelector('form');
      const rating = this.querySelector('[data-rating]');
      const body = this.querySelector('[data-review-body]');
      const wrap = this.querySelector('[data-rating-wrap]');
      if (!form || !rating || !body || !wrap) return;
      wrap.hidden = false;
      rating.required = true;
      const saved = body.value.match(/^\[24K-RATING:([1-5])\]\s*/);
      if (saved) { rating.value = saved[1]; body.value = body.value.slice(saved[0].length); }
      form.addEventListener('submit', () => {
        const clean = body.value.replace(/^\[24K-RATING:[1-5]\]\s*/, '').trim();
        if (/^[1-5]$/.test(rating.value)) body.value = '[24K-RATING:' + rating.value + ']\n' + clean;
      }, true);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["24k-hair-journey"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('k24-hair-journey')) {
    customElements.define('k24-hair-journey', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.abort = new AbortController();
        const options = {signal:this.abort.signal};
        const video = this.querySelector('video');
        const play = this.querySelector('[data-play]');
        const chapters = [...this.querySelectorAll('[data-time]')];
        const error = this.querySelector('.k24-journey__error');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let userPaused = false;
        let inView = false;
        let finished = false;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        const playVideo = () => video.play().catch(() => {
          if (video.error) error.hidden = false;
        });
        const seek = (time, run) => {
          const apply = () => {
            video.currentTime = time;
            if (run) playVideo();
          };
          if (video.readyState >= 1) apply();
          else {
            video.addEventListener('loadedmetadata', apply, {...options, once:true});
            video.load();
            if (run) playVideo();
          }
        };
        this.querySelector('.k24-journey__chapters').hidden = false;
        this.querySelector('.k24-journey__controls').hidden = false;
        // External controls keep the browser's dark control overlay off the artwork.
        video.controls = false;
        play.addEventListener('click', () => {
          userPaused = !video.paused;
          if (userPaused) video.pause();
          else { finished = false; playVideo(); }
        }, options);
        const playFrom = time => {
          userPaused = false;
          finished = false;
          seek(time, true);
        };
        this.querySelector('[data-restart]').addEventListener('click', () => playFrom(0), options);
        chapters.forEach(button => button.addEventListener('click', () => playFrom(Number(button.dataset.time)), options));
        const update = () => {
          play.textContent = video.paused ? play.dataset.labelPlay : play.dataset.labelPause;
          chapters.forEach((button,index) => button.setAttribute('aria-current', String(
            video.currentTime >= Number(button.dataset.time) &&
            (!chapters[index + 1] || video.currentTime < Number(chapters[index + 1].dataset.time))
          )));
        };
        ['play','pause','ended','timeupdate'].forEach(event => video.addEventListener(event, update, options));
        video.addEventListener('ended', () => { finished = true; }, options);
        video.addEventListener('error', () => { error.hidden = false; }, options);
        const syncPlayback = () => {
          if (!inView || document.hidden) video.pause();
          else if (!userPaused && !finished && !reducedMotion.matches) playVideo();
        };
        if ('IntersectionObserver' in window) {
          this.loader = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              video.preload = 'metadata';
              this.loader.disconnect();
            }
          }, {rootMargin:'250px'});
          this.loader.observe(video);
          this.visibility = new IntersectionObserver(entries => {
            inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25;
            syncPlayback();
          }, {threshold:[0, 0.25]});
          this.visibility.observe(video);
        } else {
          inView = true;
          syncPlayback();
        }
        document.addEventListener('visibilitychange', syncPlayback, options);
        reducedMotion.addEventListener('change', () => {
          if (reducedMotion.matches) video.pause();
          else syncPlayback();
        }, options);
        update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.loader?.disconnect();
        this.visibility?.disconnect();
        this.querySelector('video')?.pause();
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["24k-hair-parallax"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('k24-hair-parallax')){customElements.define('k24-hair-parallax',class extends HTMLElement{connectedCallback(){this.stop=new AbortController();this.reduce=matchMedia('(prefers-reduced-motion: reduce)');this.update=()=>{this.frame=0;if(this.reduce.matches){this.style.setProperty('--portrait-y','0px');return;}const r=this.getBoundingClientRect();if(r.bottom<0||r.top>innerHeight)return;const p=Math.max(0,Math.min(1,(innerHeight-r.top)/(innerHeight+r.height)));this.style.setProperty('--portrait-y',`${(p-.5)*100}px`);};this.schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(this.update);};addEventListener('scroll',this.schedule,{passive:true,signal:this.stop.signal});addEventListener('resize',this.schedule,{passive:true,signal:this.stop.signal});this.reduce.addEventListener('change',this.schedule,{signal:this.stop.signal});this.update();}disconnectedCallback(){this.stop?.abort();cancelAnimationFrame(this.frame);}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["24k-natural-scene"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('k24-natural-scene')) {
 customElements.define('k24-natural-scene', class extends HTMLElement {
  connectedCallback() {
   this.stop = new AbortController();
   this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
   this.mobile = matchMedia('(max-width: 749px)');
   this.scene = this.querySelector('.k24-natural__scene');
   if (!this.scene) return;
   this.visible = true;
   this.update = () => {
    this.frame = 0;
    if (this.reduce.matches) {
     this.style.setProperty('--scene-scale', '1');
     this.style.setProperty('--scene-y', '0px');
     return;
    }
    if (!this.visible) return;
    const r = this.scene.getBoundingClientRect();
    const progress = Math.max(0, Math.min(1, -r.top / Math.max(1, r.height)));
    this.style.setProperty('--scene-scale', String(1 + progress * (this.mobile.matches ? 0 : .09)));
    this.style.setProperty('--scene-y', String(progress * (this.mobile.matches ? 0 : 12)) + 'px');
   };
   this.schedule = () => {
    if (!this.frame && (this.visible || this.reduce.matches)) this.frame = requestAnimationFrame(this.update);
   };
   this.observer = new IntersectionObserver(entries => {
    this.visible = entries[0].isIntersecting;
    this.schedule();
   });
   this.observer.observe(this.scene);
   addEventListener('scroll', this.schedule, {passive: true, signal: this.stop.signal});
   addEventListener('resize', this.schedule, {passive: true, signal: this.stop.signal});
   this.reduce.addEventListener('change', this.schedule, {signal: this.stop.signal});
   this.update();
  }
  disconnectedCallback() {
   this.stop?.abort();
   this.observer?.disconnect();
   cancelAnimationFrame(this.frame);
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["24k-product-motion"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('k24-product-motion')){
  customElements.define('k24-product-motion',class extends HTMLElement{
    connectedCallback(){
      this.stop=new AbortController();this.reduce=matchMedia('(prefers-reduced-motion: reduce)');this.desktop=matchMedia('(min-width:990px) and (min-height:650px)');
      this.update=()=>{this.frame=0;const reduced=this.reduce.matches;this.toggleAttribute('data-active',!reduced);if(reduced){this.style.setProperty('--motion-p','0');return;}const track=this.querySelector('.k24-motion__track'),visual=this.querySelector('.k24-motion__visual');const r=track.getBoundingClientRect();if(r.bottom<0||r.top>innerHeight)return;let p;if(this.desktop.matches){p=Math.max(0,Math.min(1,-r.top/Math.max(1,r.height-innerHeight)));}else{const v=visual.getBoundingClientRect();p=Math.max(0,Math.min(1,(innerHeight-v.top)/(innerHeight+v.height)));}const e=p*p*(3-2*p);this.style.setProperty('--motion-p',p.toFixed(4));this.style.setProperty('--motion-scale',String(this.desktop.matches?.88+e*.29:.9+e*.14));this.style.setProperty('--motion-x',`${this.desktop.matches?30-e*105:12-e*24}px`);this.style.setProperty('--motion-angle',`${-7+e*10}deg`);this.style.setProperty('--motion-detail',String(Math.min(1,p*3)));};
      this.schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(this.update);};const opts={passive:true,signal:this.stop.signal};addEventListener('scroll',this.schedule,opts);addEventListener('resize',this.schedule,opts);this.reduce.addEventListener('change',this.schedule,{signal:this.stop.signal});this.update();
    }
    disconnectedCallback(){this.stop?.abort();cancelAnimationFrame(this.frame);}
  });
}

  } catch(e) { console.error(e); }
})();
})();
